import React, {Component} from 'react';
import { Field, reduxForm, change } from 'redux-form'
import { validate, renderSelect} from '../../../SHARED/helpers/validation.helper';
import { storeSelectedCinemaLocation } from '../../../SHARED/actions/filters.actions';
import { connect } from 'react-redux';


class SearchForm extends Component
{
    componentWillMount(){
        this.props.dispatch(change('searchForm', 'cityHeader', this.props.location));
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.location !== nextProps.location){
            this.props.dispatch(change('searchForm', 'cityHeader', nextProps.location));
        }
    }

    handleChange = (event) => {
        this.props.storeSelectedCinemaLocation(event.target.value);
        this.props.dispatch(change('searchForm', 'cityHeader', event.target.value));
    };

    getDropDownValues = () => {
        let values = this.props.cinemaLocations
        
        return values.map((value, i) => {   
            return (
                <option key={i} value={value.locality_name}>{value.locality_name}</option>
            )
        });
    };
    render(){
        const { handleSubmit } = this.props;
        return ( 
            <div>
                <form onSubmit={handleSubmit}>
                        <span className="choose-city d-none d-xl-inline-block">Alege oraș</span>
                            <Field
                                className="cityHeader"
                                id="cityHeader"
                                name="cityHeader"
                                type="text"
                                handleChange={this.handleChange}
                                component={renderSelect}
                                children={this.getDropDownValues()}
                                defaultValue={window.localStorage.getItem('cinema_location') || 'Bucuresti'}
                            >
                            </Field>
                        {/*<div className="col-md-6">
                            <Field
                                id="searchTerm"
                                name="searchTerm"
                                type="text"
                                placeholder="Caută"
                                component={renderField}
                            />
                        </div>*/}
                </form>
            </div>
        )
    }

};

const mapStateToProps = state => ({
    location: state.filters.selectedCinemaLocation
})

SearchForm = reduxForm({
    form: 'searchForm',
    validate: validate('searchForm')
})(SearchForm);


SearchForm = connect(mapStateToProps, {storeSelectedCinemaLocation})(SearchForm);

export default SearchForm;





// WEBPACK FOOTER //
// ./src/FO/components/searches/searchesForm.js